import img1 from '../images/slider/mockup.png'
import img2 from '../images/slider/darulUlumBanner.png'
import img3 from '../images/slider/deepavali.png'
import mobile1 from '../images/slider/darulUlumBanner-mobile.png'
import mobile2 from '../images/slider/deepavali-mobile.png'
import imgAidilAdha from '../images/slider/aidil_adha-2026.png'
import imgAidilAdhaMobile from '../images/slider/aidil_adha-2026-mobile.png'


const dataBanner = [
    {
        id: 1,

        heading: 'Beramal Tanpa Had Dimana Jua, Setiap Masa  ',
        desc: 'Al-Jariyah merupakan gerbang utama ke semua perkhidmatan berkaitan Islam yang ditawarkan oleh institusi berdaftar di bawah satu platform.',
        img: img1,
    },
    {
        id: 2,

        heading: ' ',
        desc: '',
        img: imgAidilAdha,
        imgMobile: imgAidilAdhaMobile,
    },
    {
        id: 3,

        heading: ' ',
        desc: '',
        img: img2,
        imgMobile: mobile1,
    }
]

export default dataBanner;